(function ($) {
  Drupal.behaviors.liveChat = {
    attach: function (context) {
      var $liveChatLinks = $('.js-livechat', context);

      $liveChatLinks.once().on('click', function (e) {
        try {
          lpMTagConfig.delegate.prechatWindow($);
        } catch (e) {}

        return false;
      });
    }
  };
})(jQuery);
